import { useTranslation } from 'next-i18next'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import ClockIcon from 'shared/icons/clock-icon'
import RoundedLockIcon from 'shared/icons/rounded-lock-icon'
import useStepRouter from 'modules/course/hooks/use-step-router'
import {
  CourseMenuLectureInterface,
  CourseUnavailabilityReason,
} from 'modules/course/types/course-menu-interface'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'

interface CourseAvailabilityIconProps {
  unavailabilityReason: CourseUnavailabilityReason
  lectureId?: CourseMenuLectureInterface['id']
}

export default function CourseAvailabilityIcon({
  unavailabilityReason,
  lectureId,
}: CourseAvailabilityIconProps) {
  const { t } = useTranslation()
  const { getLectureUrl } = useStepRouter()

  const isDripping = unavailabilityReason === 'dripping_access_is_not_granted_yet'
  const isLocked =
    unavailabilityReason === 'not_included_in_partial_access' ||
    unavailabilityReason === 'mandatory_assignment_not_completed'

  const LockIconWrapper = isLocked && lectureId ? LinkWithoutPrefetch : 'span'

  return (
    <span
      title={t(
        isDripping
          ? 'course.menu.module.dripping_access_unavailable.tooltip'
          : 'course.menu.module.partial_access_unavailable.tooltip',
      )}
    >
      {isDripping ? (
        <ClockIcon
          className={'h-[17px] text-THEME-disabled'}
          data-test-id={`course-menu-lecture-${lectureId}-clock-icon`}
        />
      ) : (
        <LockIconWrapper
          className={addPublicCustomClassNamePrefix('course-modules-list__module-sales-page-link')}
          href={lectureId ? getLectureUrl(lectureId) : ''}
          scroll={false}
          data-test-id={`course-menu-lecture-${lectureId}-lock-icon`}
        >
          <RoundedLockIcon className={'h-[15px] text-THEME-disabled'} />
        </LockIconWrapper>
      )}
    </span>
  )
}
